import React, { FC, Fragment, useState } from 'react';
import { Box, Button, Paper, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import { GetUserSearchesV2QueryVariables, SearchSortFieldsV2, UserStatus } from 'api';
import { EmptyState } from 'components';

import { FilterBar, Header, TableHeader } from '../components/UserManagement';
import { useGetUserSearchesV2 } from '../hooks';
import { PAGINATION_LIMIT } from '../constants';
import Table from '../components/UserManagement/Table';
import { UserSearchesV2Filter } from '../components/UserManagement/type';

const UserManagement: FC = () => {
  const { t } = useTranslation();

  const defaultFilter: UserSearchesV2Filter = {
    user_status: UserStatus.Active,
    department_ids: [],
    location_ids: [],
  };

  // Data State
  const [filter, setFilter] = useState<UserSearchesV2Filter>(defaultFilter);

  // UI State
  const hasFilters =
    !!filter.department_ids.length || !!filter.location_ids.length || !!filter.user_type;
  const [term, setTerm] = useState('');

  const variables: GetUserSearchesV2QueryVariables = {
    q: term,
    size: PAGINATION_LIMIT,
    sort: SearchSortFieldsV2.FullName,
    next_id: '',
    ...filter,
  };

  const queryOptions = useGetUserSearchesV2(variables);
  const { isEmpty } = queryOptions;

  function clearFilter() {
    setFilter(defaultFilter);
  }

  function renderTable() {
    if (isEmpty) {
      return (
        <EmptyState
          name="userManagement"
          actionComponent={
            <Button color="primary" onClick={clearFilter}>
              <Typography variant="subtitle2" align="center">
                {t('admin:clearFilters')}
              </Typography>
            </Button>
          }
        />
      );
    }

    return <Table queryVariables={variables} {...queryOptions} />;
  }

  return (
    <Fragment>
      <Box pb={2}>
        <Header />
      </Box>

      <Box pb={3}>
        <FilterBar
          filter={filter}
          setFilter={setFilter}
          hasFilters={hasFilters}
          clearFilter={clearFilter}
        />
      </Box>

      <Paper>
        <TableHeader filter={filter} setFilter={setFilter} term={term} setTerm={setTerm} />
        {renderTable()}
      </Paper>
    </Fragment>
  );
};

export default UserManagement;
